// import React, { useEffect, useState } from "react";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   InputGroup,
//   Form,
//   Table,
//   Button,
//   Modal,
//   Alert,
// } from "react-bootstrap";
// import axios from "axios";
// import { URL } from "../../config";

// const roleLabel = (role) => {
//   switch (role) {
//     case 1: return "Founder";
//     case 2: return "Super Admin";
//     case 3: return "Admin";
//     default: return "Unknown";
//   }
// };

// const roleBadgeClass = (role) => {
//   switch (role) {
//     case 1: return "bg-danger";
//     case 2: return "bg-primary";
//     case 3: return "bg-secondary";
//     default: return "bg-dark";
//   }
// };

// const Admins = () => {
//   const [admins, setAdmins] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [search, setSearch] = useState("");

//   const [errorMessage, setErrorMessage] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");

//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showPasswordModal, setShowPasswordModal] = useState(false);

//   const [selectedAdmin, setSelectedAdmin] = useState(null);

//   const [addForm, setAddForm] = useState({
//     name: "",
//     email: "",
//     password: "",
//     role: 3, // default Admin
//   });

//   const [editForm, setEditForm] = useState({
//     name: "",
//     email: "",
//     role: 3,
//   });

//   const [passwordForm, setPasswordForm] = useState({
//     newPassword: "",
//     confirmPassword: "",
//   });

//   useEffect(() => {
//     fetchAdmins();
//   }, []);

//   const fetchAdmins = async () => {
//     try {
//       const res = await axios.get(`${URL}/admins`);
//       setAdmins(res.data);
//       setFiltered(res.data);
//     } catch (err) {
//       console.error(err);
//       setErrorMessage("Failed to load admins.");
//     }
//   };

//   const handleSearch = (value) => {
//     setSearch(value);
//     if (!value.trim()) {
//       setFiltered(admins);
//       return;
//     }
//     const v = value.toLowerCase();
//     setFiltered(
//       admins.filter(
//         (a) =>
//           a.name.toLowerCase().includes(v) ||
//           a.email.toLowerCase().includes(v) ||
//           (a.roleLabel || roleLabel(a.role)).toLowerCase().includes(v)
//       )
//     );
//   };

//   const resetMessages = () => {
//     setErrorMessage("");
//     setSuccessMessage("");
//   };

//   const openAddModal = () => {
//     resetMessages();
//     setAddForm({ name: "", email: "", password: "", role: 3 });
//     setShowAddModal(true);
//   };

//   const openEditModal = (admin) => {
//     resetMessages();
//     setSelectedAdmin(admin);
//     setEditForm({
//       name: admin.name,
//       email: admin.email,
//       role: admin.role,
//     });
//     setShowEditModal(true);
//   };

//   const openPasswordModal = (admin) => {
//     resetMessages();
//     setSelectedAdmin(admin);
//     setPasswordForm({ newPassword: "", confirmPassword: "" });
//     setShowPasswordModal(true);
//   };

//   const closeModals = () => {
//     setShowAddModal(false);
//     setShowEditModal(false);
//     setShowPasswordModal(false);
//     setSelectedAdmin(null);
//     resetMessages();
//   };

//   const handleAddChange = (e) => {
//     const { name, value } = e.target;
//     setAddForm((prev) => ({
//       ...prev,
//       [name]: name === "role" ? Number(value) : value,
//     }));
//   };

//   const handleEditChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm((prev) => ({
//       ...prev,
//       [name]: name === "role" ? Number(value) : value,
//     }));
//   };

//   const handlePasswordChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleAddSubmit = async (e) => {
//     e.preventDefault();
//     resetMessages();

//     if (!addForm.name || !addForm.email || !addForm.password) {
//       setErrorMessage("Please fill in all required fields.");
//       return;
//     }

//     try {
//       const body = {
//         name: addForm.name,
//         email: addForm.email,
//         password: addForm.password,
//         role: addForm.role,
//       };
//       const res = await axios.post(`${URL}/admins`, body);
//       setSuccessMessage("Admin created successfully.");
//       setShowAddModal(false);
//       await fetchAdmins();
//     } catch (err) {
//       console.error(err);
//       setErrorMessage(err.response?.data?.error || "Failed to create admin.");
//     }
//   };

//   const handleEditSubmit = async (e) => {
//     e.preventDefault();
//     resetMessages();
//     if (!selectedAdmin) return;

//     try {
//       const body = {
//         name: editForm.name,
//         email: editForm.email,
//         role: editForm.role,
//       };
//       const res = await axios.put(`${URL}/admins/${selectedAdmin.Id}`, body);
//       setSuccessMessage("Admin updated successfully.");
//       setShowEditModal(false);
//       await fetchAdmins();
//     } catch (err) {
//       console.error(err);
//       setErrorMessage(err.response?.data?.error || "Failed to update admin.");
//     }
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     resetMessages();
//     if (!selectedAdmin) return;

//     if (!passwordForm.newPassword || !passwordForm.confirmPassword) {
//       setErrorMessage("Please fill in both password fields.");
//       return;
//     }
//     if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//       setErrorMessage("Passwords do not match.");
//       return;
//     }

//     try {
//       await axios.post(`${URL}/admins/${selectedAdmin.Id}/change-password`, {
//         newPassword: passwordForm.newPassword,
//       });
//       setSuccessMessage("Password changed successfully.");
//       setShowPasswordModal(false);
//     } catch (err) {
//       console.error(err);
//       setErrorMessage(
//         err.response?.data?.error || "Failed to change password."
//       );
//     }
//   };

//   const handleDelete = async (admin) => {
//     resetMessages();
//     if (admin.role === 1) {
//       setErrorMessage("Founder admin cannot be deleted.");
//       return;
//     }
//     if (!window.confirm(`Delete admin "${admin.name}"?`)) return;

//     try {
//       await axios.delete(`${URL}/admins/${admin.Id}`);
//       setSuccessMessage("Admin deleted successfully.");
//       await fetchAdmins();
//     } catch (err) {
//       console.error(err);
//       setErrorMessage(err.response?.data?.error || "Failed to delete admin.");
//     }
//   };

//   return (
//     <Container>
//       {errorMessage && (
//         <Alert
//           variant="danger"
//           onClose={() => setErrorMessage("")}
//           dismissible
//           className="mt-3"
//         >
//           {errorMessage}
//         </Alert>
//       )}
//       {successMessage && (
//         <Alert
//           variant="success"
//           onClose={() => setSuccessMessage("")}
//           dismissible
//           className="mt-3"
//         >
//           {successMessage}
//         </Alert>
//       )}

//       <Card className="mt-3">
//         <Card.Header className="adminUserorder-header">
//           <h4 className="adminUserorder-title">Admin Accounts</h4>
//         </Card.Header>

//         <Card.Body>
//           {/* Search + Add */}
//           <Row className="align-items-center mb-3">
//             <Col md={8} sm={12} className="mb-2">
//               <InputGroup>
//                 <Form.Control
//                   placeholder="Search by name, email, role"
//                   value={search}
//                   onChange={(e) => handleSearch(e.target.value)}
//                 />
//                 <InputGroup.Text style={{ fontSize: "smaller" }}>
//                   search
//                 </InputGroup.Text>
//               </InputGroup>
//             </Col>
//             <Col md={4} sm={12} className="text-md-end text-sm-start">
//               <Button variant="success" onClick={openAddModal}>
//                 + Add Admin
//               </Button>
//             </Col>
//           </Row>

//           <div className="table-responsive">
//             <Table striped hover size="sm" className="table-borderless">
//               <thead>
//                 <tr>
//                   <th style={{ textAlign: "left" }}>ID</th>
//                   <th style={{ textAlign: "left" }}>Name</th>
//                   <th style={{ textAlign: "left" }}>Email</th>
//                   <th style={{ textAlign: "left" }}>Role</th>
//                   <th style={{ textAlign: "left" }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((admin) => (
//                   <tr key={admin.Id}>
//                     <td style={{ textAlign: "left" }}>{admin.Id}</td>
//                     <td style={{ textAlign: "left" }}>{admin.name}</td>
//                     <td style={{ textAlign: "left" }}>{admin.email}</td>
//                     <td style={{ textAlign: "left" }}>
//                       <span
//                         className={`badge ${roleBadgeClass(admin.role)}`}
//                       >
//                         {admin.roleLabel || roleLabel(admin.role)}
//                       </span>
//                     </td>
//                     <td style={{ textAlign: "left" }}>
//                       <Button
//                         variant="none"
//                         className="p-0 me-2"
//                         onClick={() => openEditModal(admin)}
//                       >
//                         <i
//                           className="bi bi-pencil-square"
//                           style={{ color: "blue" }}
//                         ></i>
//                       </Button>
//                       <Button
//                         variant="none"
//                         className="p-0 me-2"
//                         onClick={() => openPasswordModal(admin)}
//                       >
//                         <i
//                           className="bi bi-key-fill"
//                           style={{ color: "orange" }}
//                         ></i>
//                       </Button>
//                       <Button
//                         variant="none"
//                         className="p-0"
//                         onClick={() => handleDelete(admin)}
//                         disabled={admin.role === 1}
//                       >
//                         <i
//                           className="bi bi-trash3-fill"
//                           style={{
//                             color: admin.role === 1 ? "gray" : "red",
//                             cursor:
//                               admin.role === 1 ? "not-allowed" : "pointer",
//                           }}
//                         ></i>
//                       </Button>
//                     </td>
//                   </tr>
//                 ))}
//                 {filtered.length === 0 && (
//                   <tr>
//                     <td colSpan={5} className="text-center py-3">
//                       No admin accounts found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </div>
//         </Card.Body>
//       </Card>

//       {/* Add Admin Modal */}
//       <Modal show={showAddModal} onHide={closeModals} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100 text-center fw-bold">
//             Add Admin
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleAddSubmit}>
//             <Form.Group className="mb-3">
//               <Form.Label>Full Name</Form.Label>
//               <Form.Control
//                 name="name"
//                 value={addForm.name}
//                 onChange={handleAddChange}
//                 placeholder="e.g. John Doe"
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 value={addForm.email}
//                 onChange={handleAddChange}
//                 placeholder="admin@example.com"
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Password</Form.Label>
//               <Form.Control
//                 type="password"
//                 name="password"
//                 value={addForm.password}
//                 onChange={handleAddChange}
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Role</Form.Label>
//               <Form.Select
//                 name="role"
//                 value={addForm.role}
//                 onChange={handleAddChange}
//               >
//                 {/* Founder (1) intentionally not listed here */}
//                 <option value={2}>Super Admin</option>
//                 <option value={3}>Admin (view only)</option>
//               </Form.Select>
//             </Form.Group>
//             <div className="d-flex justify-content-center">
//               <Button
//                 variant="outline-success"
//                 className="mt-2"
//                 type="submit"
//                 style={{ padding: "8px 24px", borderRadius: "10px" }}
//               >
//                 Create Admin
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Edit Admin Modal */}
//       <Modal show={showEditModal} onHide={closeModals} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100 text-center fw-bold">
//             Edit Admin
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleEditSubmit}>
//             <Form.Group className="mb-3">
//               <Form.Label>Full Name</Form.Label>
//               <Form.Control
//                 name="name"
//                 value={editForm.name}
//                 onChange={handleEditChange}
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 value={editForm.email}
//                 onChange={handleEditChange}
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Role</Form.Label>
//               <Form.Select
//                 name="role"
//                 value={editForm.role}
//                 onChange={handleEditChange}
//                 disabled={selectedAdmin?.role === 1}
//               >
//                 {selectedAdmin?.role === 1 && (
//                   <option value={1}>Founder</option>
//                 )}
//                 <option value={2}>Super Admin</option>
//                 <option value={3}>Admin (view only)</option>
//               </Form.Select>
//               {selectedAdmin?.role === 1 && (
//                 <Form.Text className="text-muted">
//                   Founder role cannot be changed via UI.
//                 </Form.Text>
//               )}
//             </Form.Group>
//             <div className="d-flex justify-content-center">
//               <Button
//                 variant="primary"
//                 className="mt-2"
//                 type="submit"
//                 style={{ padding: "8px 24px", borderRadius: "10px" }}
//               >
//                 Save Changes
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Change Password Modal */}
//       <Modal show={showPasswordModal} onHide={closeModals} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100 text-center fw-bold">
//             Change Password
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handlePasswordSubmit}>
//             <Form.Group className="mb-3">
//               <Form.Label>New Password</Form.Label>
//               <Form.Control
//                 type="password"
//                 name="newPassword"
//                 value={passwordForm.newPassword}
//                 onChange={handlePasswordChange}
//                 required
//               />
//             </Form.Group>
//             <Form.Group className="mb-3">
//               <Form.Label>Confirm Password</Form.Label>
//               <Form.Control
//                 type="password"
//                 name="confirmPassword"
//                 value={passwordForm.confirmPassword}
//                 onChange={handlePasswordChange}
//                 required
//               />
//             </Form.Group>
//             <div className="d-flex justify-content-center">
//               <Button
//                 variant="primary"
//                 className="mt-2"
//                 type="submit"
//                 style={{ padding: "8px 24px", borderRadius: "10px" }}
//               >
//                 Update Password
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </Container>
//   );
// };

// export default Admins;




import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  InputGroup,
  Form,
  Table,
  Button,
  Modal,
  Alert,
} from "react-bootstrap";
import axios from "axios";
import { URL } from "../../config";

const roleLabel = (role) => {
  switch (Number(role)) {
    case 1:
      return "Founder";
    case 2:
      return "Super Admin";
    case 3:
      return "Admin";
    default:
      return "Unknown";
  }
};

const roleBadgeClass = (role) => {
  switch (Number(role)) {
    case 1:
      return "bg-danger";
    case 2:
      return "bg-primary";
    case 3:
      return "bg-secondary";
    default:
      return "bg-dark";
  }
};

const Admins = () => {
  const [admins, setAdmins] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const [selectedAdmin, setSelectedAdmin] = useState(null);

  const [addForm, setAddForm] = useState({
    name: "",
    email: "",
    password: "",
    role: 3, // default Admin
  });

  const [editForm, setEditForm] = useState({
    name: "",
    email: "",
    role: 3,
  });

  const [passwordForm, setPasswordForm] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [currentAdmin, setCurrentAdmin] = useState(null);

  const token = localStorage.getItem("adminToken");

  useEffect(() => {
    const stored = localStorage.getItem("adminInfo");
    if (stored) {
      try {
        setCurrentAdmin(JSON.parse(stored));
      } catch (e) {
        console.error("Failed to parse adminInfo:", e);
      }
    }
  }, []);

  const isFounder = Number(currentAdmin?.role) === 1;

  useEffect(() => {
    if (!token) {
      setErrorMessage("Not authorized. Please login as admin.");
      return;
    }
    fetchAdmins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const fetchAdmins = async () => {
    try {
      const res = await axios.get(`${URL}/admins`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAdmins(res.data);
      setFiltered(res.data);
    } catch (err) {
      console.error(err);
      setErrorMessage(
        err.response?.data?.error || "Failed to load admins."
      );
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
    if (!value.trim()) {
      setFiltered(admins);
      return;
    }
    const v = value.toLowerCase();
    setFiltered(
      admins.filter(
        (a) =>
          a.name.toLowerCase().includes(v) ||
          a.email.toLowerCase().includes(v) ||
          (a.roleLabel || roleLabel(a.role)).toLowerCase().includes(v)
      )
    );
  };

  const resetMessages = () => {
    setErrorMessage("");
    setSuccessMessage("");
  };

  const openAddModal = () => {
    resetMessages();
    setAddForm({ name: "", email: "", password: "", role: 3 });
    setShowAddModal(true);
  };

  const openEditModal = (admin) => {
    resetMessages();
    setSelectedAdmin(admin);
    setEditForm({
      name: admin.name,
      email: admin.email,
      role: admin.role,
    });
    setShowEditModal(true);
  };

  const openPasswordModal = (admin) => {
    resetMessages();
    setSelectedAdmin(admin);
    setPasswordForm({ newPassword: "", confirmPassword: "" });
    setShowPasswordModal(true);
  };

  const closeModals = () => {
    setShowAddModal(false);
    setShowEditModal(false);
    setShowPasswordModal(false);
    setSelectedAdmin(null);
    resetMessages();
  };

  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddForm((prev) => ({
      ...prev,
      [name]: name === "role" ? Number(value) : value,
    }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: name === "role" ? Number(value) : value,
    }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    resetMessages();

    if (!isFounder) {
      setErrorMessage("Only Founder can create admins.");
      return;
    }

    if (!addForm.name || !addForm.email || !addForm.password) {
      setErrorMessage("Please fill in all required fields.");
      return;
    }

    try {
      const body = {
        name: addForm.name,
        email: addForm.email,
        password: addForm.password,
        role: addForm.role,
      };
      await axios.post(`${URL}/admins`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSuccessMessage("Admin created successfully.");
      setShowAddModal(false);
      await fetchAdmins();
    } catch (err) {
      console.error(err);
      setErrorMessage(err.response?.data?.error || "Failed to create admin.");
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    resetMessages();
    if (!selectedAdmin) return;

    if (!isFounder) {
      setErrorMessage("Only Founder can update admins.");
      return;
    }

    try {
      const body = {
        name: editForm.name,
        email: editForm.email,
        role: editForm.role,
      };
      await axios.put(`${URL}/admins/${selectedAdmin.Id}`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSuccessMessage("Admin updated successfully.");
      setShowEditModal(false);
      await fetchAdmins();
    } catch (err) {
      console.error(err);
      setErrorMessage(err.response?.data?.error || "Failed to update admin.");
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    resetMessages();
    if (!selectedAdmin) return;

    if (!isFounder) {
      setErrorMessage("Only Founder can change admin passwords.");
      return;
    }

    if (!passwordForm.newPassword || !passwordForm.confirmPassword) {
      setErrorMessage("Please fill in both password fields.");
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      await axios.post(
        `${URL}/admins/${selectedAdmin.Id}/change-password`,
        { newPassword: passwordForm.newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSuccessMessage("Password changed successfully.");
      setShowPasswordModal(false);
    } catch (err) {
      console.error(err);
      setErrorMessage(
        err.response?.data?.error || "Failed to change password."
      );
    }
  };

  const handleDelete = async (admin) => {
    resetMessages();

    if (!isFounder) {
      setErrorMessage("Only Founder can delete admins.");
      return;
    }

    if (admin.role === 1) {
      setErrorMessage("Founder admin cannot be deleted.");
      return;
    }
    if (!window.confirm(`Delete admin "${admin.name}"?`)) return;

    try {
      await axios.delete(`${URL}/admins/${admin.Id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSuccessMessage("Admin deleted successfully.");
      await fetchAdmins();
    } catch (err) {
      console.error(err);
      setErrorMessage(err.response?.data?.error || "Failed to delete admin.");
    }
  };

  return (
    <Container>
      {errorMessage && (
        <Alert
          variant="danger"
          onClose={() => setErrorMessage("")}
          dismissible
          className="mt-3"
        >
          {errorMessage}
        </Alert>
      )}
      {successMessage && (
        <Alert
          variant="success"
          onClose={() => setSuccessMessage("")}
          dismissible
          className="mt-3"
        >
          {successMessage}
        </Alert>
      )}

      <Card className="mt-3">
        <Card.Header className="adminUserorder-header">
          <h4 className="adminUserorder-title">Admin Accounts</h4>
        </Card.Header>

        <Card.Body>
          {/* Search + Add */}
          <Row className="align-items-center mb-3">
            <Col md={8} sm={12} className="mb-2">
              <InputGroup>
                <Form.Control
                  placeholder="Search by name, email, role"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <InputGroup.Text style={{ fontSize: "smaller" }}>
                  search
                </InputGroup.Text>
              </InputGroup>
            </Col>
            <Col md={4} sm={12} className="text-md-end text-sm-start">
              {isFounder && (
                <Button variant="success" onClick={openAddModal}>
                  + Add Admin
                </Button>
              )}
            </Col>
          </Row>

          <div className="table-responsive">
            <Table striped hover size="sm" className="table-borderless">
              <thead>
                <tr>
                  <th style={{ textAlign: "left" }}>ID</th>
                  <th style={{ textAlign: "left" }}>Name</th>
                  <th style={{ textAlign: "left" }}>Email</th>
                  <th style={{ textAlign: "left" }}>Role</th>
                  <th style={{ textAlign: "left" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((admin) => (
                  <tr key={admin.Id}>
                    <td style={{ textAlign: "left" }}>{admin.Id}</td>
                    <td style={{ textAlign: "left" }}>{admin.name}</td>
                    <td style={{ textAlign: "left" }}>{admin.email}</td>
                    <td style={{ textAlign: "left" }}>
                      <span
                        className={`badge ${roleBadgeClass(admin.role)}`}
                      >
                        {admin.roleLabel || roleLabel(admin.role)}
                      </span>
                    </td>
                    <td style={{ textAlign: "left" }}>
                      {isFounder ? (
                        <>
                          <Button
                            variant="none"
                            className="p-0 me-2"
                            onClick={() => openEditModal(admin)}
                          >
                            <i
                              className="bi bi-pencil-square"
                              style={{ color: "blue" }}
                            ></i>
                          </Button>
                          <Button
                            variant="none"
                            className="p-0 me-2"
                            onClick={() => openPasswordModal(admin)}
                          >
                            <i
                              className="bi bi-key-fill"
                              style={{ color: "orange" }}
                            ></i>
                          </Button>
                          <Button
                            variant="none"
                            className="p-0"
                            onClick={() => handleDelete(admin)}
                            disabled={admin.role === 1}
                          >
                            <i
                              className="bi bi-trash3-fill"
                              style={{
                                color: admin.role === 1 ? "gray" : "red",
                                cursor:
                                  admin.role === 1
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            ></i>
                          </Button>
                        </>
                      ) : (
                        <span
                          className="text-muted"
                          style={{ fontSize: "12px" }}
                        >
                          View only
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={5} className="text-center py-3">
                      No admin accounts found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Add Admin Modal */}
      <Modal show={showAddModal} onHide={closeModals} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center fw-bold">
            Add Admin
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleAddSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                name="name"
                value={addForm.name}
                onChange={handleAddChange}
                placeholder="e.g. John Doe"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={addForm.email}
                onChange={handleAddChange}
                placeholder="admin@example.com"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={addForm.password}
                onChange={handleAddChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Role</Form.Label>
              <Form.Select
                name="role"
                value={addForm.role}
                onChange={handleAddChange}
              >
                {/* Founder (1) intentionally not listed here */}
                <option value={2}>Super Admin</option>
                <option value={3}>Admin (view only)</option>
              </Form.Select>
            </Form.Group>
            <div className="d-flex justify-content-center">
              <Button
                variant="outline-success"
                className="mt-2"
                type="submit"
                style={{ padding: "8px 24px", borderRadius: "10px" }}
              >
                Create Admin
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Admin Modal */}
      <Modal show={showEditModal} onHide={closeModals} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center fw-bold">
            Edit Admin
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                name="name"
                value={editForm.name}
                onChange={handleEditChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={editForm.email}
                onChange={handleEditChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Role</Form.Label>
              <Form.Select
                name="role"
                value={editForm.role}
                onChange={handleEditChange}
                disabled={selectedAdmin?.role === 1}
              >
                {selectedAdmin?.role === 1 && (
                  <option value={1}>Founder</option>
                )}
                <option value={2}>Super Admin</option>
                <option value={3}>Admin (view only)</option>
              </Form.Select>
              {selectedAdmin?.role === 1 && (
                <Form.Text className="text-muted">
                  Founder role cannot be changed via UI.
                </Form.Text>
              )}
            </Form.Group>
            <div className="d-flex justify-content-center">
              <Button
                variant="primary"
                className="mt-2"
                type="submit"
                style={{ padding: "8px 24px", borderRadius: "10px" }}
              >
                Save Changes
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Change Password Modal */}
      <Modal show={showPasswordModal} onHide={closeModals} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center fw-bold">
            Change Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handlePasswordSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                value={passwordForm.newPassword}
                onChange={handlePasswordChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                value={passwordForm.confirmPassword}
                onChange={handlePasswordChange}
                required
              />
            </Form.Group>
            <div className="d-flex justify-content-center">
              <Button
                variant="primary"
                className="mt-2"
                type="submit"
                style={{ padding: "8px 24px", borderRadius: "10px" }}
              >
                Update Password
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Admins;
